export const CAR_EXCHANGE_TYPE = {
	NO: 'NO',
	YES: 'YES',
	UNKNOWN: 'UNKNOWN',
};

export const ACCIDENT_TYPE = {
	NO: 'NO',
	EXCHANGE: 'EXCHANGE',
	SHEETING: 'SHEETING',
};

export const INIT_CAR_STATUS = {
	smartKeyCount: null,
	panelScratchCount: null,
	wheelScratchCount: null,
	badTireStatusType: null,
	additionalRepairNeededPart: '',
	exchangeType: null, // CAR_EXCHANGE_TYPE
	exchangeComment: '',
	panel: {
		frontBumper: null, // ACCIDENT_TYPE
		radiatorSupport: null,
		bonnet: null,
		roofPanel: null,
		trunkDoor: null,
		rearBumper: null,
		frontSidePanelLeft: null,
		frontSidePanelRight: null,
		frontDoorLeft: null,
		frontDoorRight: null,
		rearDoorLeft: null,
		rearDoorRight: null,
	},
	frame: {
		frontPanel: null, // ACCIDENT_TYPE
		sideMemberLeft: null,
		sideMemberRight: null,
		crossMember: null,
		floorPanel: null,
		rearWheelHouseLeft: null,
		rearWheelHouseRight: null,
		trunkFloor: null,
		rearPanel: null,
		frontInsidePanelLeft: null,
		frontInsidePanelRight: null,
		frontWheelHouseLeft: null,
		frontWheelHouseRight: null,
		frontPillarLeft: null,
		frontPillarRight: null,
		middlePillarLeft: null,
		middlePillarRight: null,
		rearPillarLeft: null,
		rearPillarRight: null,
		sideSillPanelLeft: null,
		sideSillPanelRight: null,
		rearSidePanelLeft: null,
		rearSidePanelRight: null,
	},
	additionalComment: {
		[CAR_EXCHANGE_TYPE.YES]: '',
		[CAR_EXCHANGE_TYPE.UNKNOWN]: '',
	},
};

export const CAR_ACCIDENT_OBJ = {
	panel: {
		frontBumper: {
			text: '앞범퍼',
			xAxis: '50%',
			yAxis: '-2%',
		},
		radiatorSupport: {
			text: '라디에이터서포트',
			xAxis: '50%',
			yAxis: '7%',
		},
		bonnet: {
			text: '본넷',
			xAxis: '50%',
			yAxis: '17%',
		},
		roofPanel: {
			text: '루프패널',
			xAxis: '50%',
			yAxis: '53%',
		},
		trunkDoor: {
			text: '트렁크도어',
			xAxis: '50%',
			yAxis: '80%',
		},
		rearBumper: {
			text: '뒷범퍼',
			xAxis: '50%',
			yAxis: '92%',
		},
		frontSidePanelLeft: {
			text: '앞휀더',
			xAxis: '14%',
			yAxis: '20%',
		},
		frontSidePanelRight: {
			text: '앞휀더',
			xAxis: '86%',
			yAxis: '20%',
		},
		frontDoorLeft: {
			text: '앞도어',
			xAxis: '14%',
			yAxis: '43%',
		},
		frontDoorRight: {
			text: '앞도어',
			xAxis: '86%',
			yAxis: '43%',
		},
		rearDoorLeft: {
			text: '뒷도어',
			xAxis: '14%',
			yAxis: '58%',
		},
		rearDoorRight: {
			text: '뒷도어',
			xAxis: '86%',
			yAxis: '58%',
		},
	},
	frame: {
		frontPanel: {
			text: '프론트패널',
			xAxis: '50%',
			yAxis: '4%',
		},
		sideMemberLeft: {
			text: '사이드멤버',
			xAxis: '44%',
			yAxis: '19%',
			vertical: true,
		},
		sideMemberRight: {
			text: '사이드멤버',
			xAxis: '56%',
			yAxis: '19%',
			vertical: true,
		},
		crossMember: {
			text: '크로스멤버',
			xAxis: '50%',
			yAxis: '35%',
		},
		floorPanel: {
			text: '플로어패널',
			xAxis: '50%',
			yAxis: '49%',
		},
		rearWheelHouseLeft: {
			text: '뒤휠하우스',
			xAxis: '31%',
			yAxis: '72%',
		},
		rearWheelHouseRight: {
			text: '뒤휠하우스',
			xAxis: '69%',
			yAxis: '72%',
		},
		trunkFloor: {
			text: '트렁크플로어',
			xAxis: '50%',
			yAxis: '80%',
		},
		rearPanel: {
			text: '리어패널',
			xAxis: '50%',
			yAxis: '89%',
		},
		frontInsidePanelLeft: {
			text: '인사이드패널',
			xAxis: '21%',
			yAxis: '14%',
		},
		frontInsidePanelRight: {
			text: '인사이드패널',
			xAxis: '79%',
			yAxis: '14%',
		},
		frontWheelHouseLeft: {
			text: '앞휠하우스',
			xAxis: '23%',
			yAxis: '23%',
		},
		frontWheelHouseRight: {
			text: '앞휠하우스',
			xAxis: '77%',
			yAxis: '23%',
		},
		frontPillarLeft: {
			text: 'A필러',
			xAxis: '23%',
			yAxis: '32%',
		},
		frontPillarRight: {
			text: 'A필러',
			xAxis: '77%',
			yAxis: '32%',
		},
		middlePillarLeft: {
			text: 'B필러',
			xAxis: '23%',
			yAxis: '48%',
		},
		middlePillarRight: {
			text: 'B필러',
			xAxis: '77%',
			yAxis: '48%',
		},
		rearPillarLeft: {
			text: 'C필러',
			xAxis: '23%',
			yAxis: '64%',
		},
		rearPillarRight: {
			text: 'C필러',
			xAxis: '77%',
			yAxis: '64%',
		},
		sideSillPanelLeft: {
			text: '사이드실패널',
			xAxis: '6%',
			yAxis: '44%',
			vertical: true,
		},
		sideSillPanelRight: {
			text: '사이드실패널',
			xAxis: '94%',
			yAxis: '44%',
			vertical: true,
		},
		rearSidePanelLeft: {
			text: '뒤휀더',
			xAxis: '12%',
			yAxis: '79%',
		},
		rearSidePanelRight: {
			text: '뒤휀더',
			xAxis: '88%',
			yAxis: '79%',
		},
	},
};
